<template>
  <div>
    <div v-if="isBalanceUser">
      <div v-if="userContext && userContext.qualification_status === 'APPROVED'">
        <div>
          <p v-if="creditAvailable" class="b1 line-height-26">You have Net-60 payment terms on this order and will be
            charged 60 days after shipment.</p>
          <p v-else class="b1 line-height-26">You exceeded your available Net-60 terms and will be charged on
            shipment.</p>
          <p class="b1 line-height-26">{{ creditAvailable ? creditLimit : "$0.00" }} Net-60 credit remaining</p>
        </div>
      </div>
      <div v-else-if="userContext && userContext.qualification_status === 'NOT_APPLIED'">
        <p class="b1 line-height-26">
          Apply for financing to unlock Net-60 terms.
        </p>
      </div>
      <p class="mt-25 b2 secondary-grey">Bulletin will place an authorization hold on your card at checkout. This will
        be released after 7-10 business days or once your items are shipped and the transaction is completed.</p>
    </div>
    <div v-else>
      <p v-if="hasChosenNet0" class="text-muted line-height-26">You have selected to be charged on shipment.</p>
      <div v-else-if="payment_terms === 'NET_60'">
        <p class="b1 line-height-26">You have Net 60 payment terms on this order and will be charged 60 days after shipment.</p>
        <p class="b1 line-height-26">${{net_60_credit_remaining }} Net 60 credit remaining.</p>
      </div>
      <p v-else-if="payment_terms === 'NET_0'" class="b1 line-height-26">
        You exceeded your available Net 60 terms and will be charged on shipment.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BalanceApi from "@/services/api/balanceApi";

const BalanceApiService = new BalanceApi();

export default {
  data: function() {
    return {
      creditAvailable: true,
      creditLimit: null
    };
  },
  props: ["payment_terms", "net_60_credit_remaining", "has-chosen-net0"],
  watch: {
    "userContext": async function() {
        await this.configBalance();
    }
  },
  computed: {
    ...mapGetters({
      userContext: "userContext"
    }),
    isBalanceUser() {
      return this.$store.getters.userContext?.use_balance;
      // && this.userContext?.use_balance;
    }
  },
  mounted() {
    this.configBalance();
  },
  methods: {
    async configBalance() {
      if (this.userContext?.use_balance) {
        const { data } = await BalanceApiService.getBuyerCreditLimit(this.userContext.balance_id);
        this.creditAvailable = data.creditLimit > 0;
        this.creditLimit = this.$utils.toDollars(data.creditLimit)
      }
    }
  }
};
</script>
